<template>
  <a
    class="context__menu-item-link"
    :class="{
      'context__menu-item-link--loading': saving,
      disabled: disabled || saving,
    }"
    @click="saveAsTemplate()"
  >
    <i class="context__menu-item-icon iconoir-bookmark-empty"></i>
    {{ $t('templateCenter.saveAsTemplate') }}
  </a>
</template>

<script>
/**
 * Origem Flow: item de contexto "Salvar como modelo" — duplica a aplicação e
 * renomeia a cópia com o prefixo de modelo, deixando-a disponível na Central
 * de modelos. O original não é alterado.
 */
import { notifyIf } from '@baserow/modules/core/utils/error'
import {
  TEMPLATE_PREFIX,
  duplicateApplicationAndRename,
} from '@baserow/modules/core/utils/applicationTemplates'

export default {
  name: 'SidebarSaveAsTemplateContextItem',
  props: {
    application: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['click'],
  data() {
    return {
      saving: false,
    }
  },
  methods: {
    async saveAsTemplate() {
      if (this.saving || this.disabled) {
        return
      }
      this.saving = true
      this.$emit('click')
      try {
        await duplicateApplicationAndRename(
          this,
          this.application,
          `${TEMPLATE_PREFIX}${this.application.name}`
        )
        this.$store.dispatch('toast/info', {
          title: this.$t('templateCenter.title'),
          message: this.$t('templateCenter.savedAsTemplate', {
            name: this.application.name,
          }),
        })
      } catch (error) {
        notifyIf(error, 'application')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
